module.exports = function(menus) {
	'use strict'
	menus.directive('checkedListMenuDir',checkedListMenuDir);
	checkedListMenuDir.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
	function checkedListMenuDir($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
		return {
			restrict: 'E',
			scope:{
				type:'=',
				list:'=',
                itemChecked:'=',
				menu:'=',
			},
			replace:true,
			template: require('./partial/checkedListMenu.html'),
			link: function(scope, ele, $attrs, ctrl) {
                function chechedRecursion(id, title, item, menuChildrenArray) {
                    scope.itemChecked[id] = true;
					if(!scope.menu) {
						scope.menu = []
					}
					var obj = {
						objId: id,
						title: title,
						type: scope.type,
						url:item.url,
						_id:Math.random().toString(36).substring(2, 32),
						children:[]
					}
					if(item.ancestors && item.ancestors.length>0) {
						obj.ancestors = item.ancestors
					}
					scope.menu.push(obj)
                    if(item.children && item.children.length>0) {
                        for(var i = 0;i<item.children.length;i++) {
                            if(scope.type == 'page') {
                                chechedRecursion(item.children[i].slug, item.children[i].title, item.children[i], obj.children)
                            } else {
                                chechedRecursion(item.children[i]._id, item.children[i].name, item.children[i], obj.children)
                            }
                        }
                    }
                }
				function uncheckedRecursion(id, item,menu) {
					scope.itemChecked[id] = false;
					if(item.children && item.children.length>0) {
						for(var i = 0;i<item.children.length;i++) {
                            if(scope.type == 'page') {
                                uncheckedRecursion(item.children[i].slug, item.children[i])
                            } else {
                                uncheckedRecursion(item.children[i]._id, item.children[i])
                            }
                        }
					}
					if(scope.menu && scope.menu.length>0) {
						var index =-1;
						for(var i = 0; i<scope.menu.length;i++) {
							if(scope.menu[i].objId == id) {
								index = i
								break
							}
						}
						if(index>-1) {
							scope.menu.splice(index,1)
						}
					}
				}
				scope.updateSelection = function(id, checked, title, item) {
					if(checked) {
                        chechedRecursion(id, title,item)
					} else {
						uncheckedRecursion(id,item)
					}
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/menusModule/menus/js/directive/checkedListMenuDirective.js
// module id = 526
// module chunks = 0